module.exports = __webpack_public_path__ + "static/media/lumbering2.ae9c63c1.jpg";